import React, { Component } from 'react';
import {
  arrayOf, bool, func, shape, string
} from 'prop-types';
import classNames from 'classnames';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import MediaGalleryOverlayMobile from '../MediaGalleryOverlayMobile';
import Helper from '../../Helper';
import '../../media-gallery.style.scss';
import './media-gallery-mobile.style.scss';
import { thumbnailClick, mediaClick } from '../../../publisher';

class MediaGalleryMobile extends Component {
  state = {
    mainImage: null,
    selectedMainImageIndex: null,
    selectedThumbnailIndex: null,
    children: [],
    overlayOpened: false,
    thumbnails: []
  };

  componentDidMount() {
    this.updatePageLayout();
  }

  componentDidUpdate(prevProps) {
    const { media = {}, product } = this.props;
    const { main = [] } = media;
    if (prevProps.product.itemId !== product.itemId
       || (prevProps.media && prevProps.media.main[0] !== main[0])) {
      this.updatePageLayout();
    }
  }

  onMainImageClick = (images, index, thumbnailType) => {
    const { thumbnails } = this.state;
    const payload = {
      eventName: 'expanded-view',
      primaryCategory: 'overlay'
    };
    thumbnailClick(payload);

    const thumbnailPayload = {
      section: 'media',
      component: 'thumbnails',
      target: thumbnailType || 'n/a',
      position: 'n/a'
    };

    mediaClick(thumbnailPayload);

    this.setState({
      overlayOpened: true, mainImage: images[index], selectedMainImageIndex: index, thumbnails, selectedThumbnailIndex: index
    });
    if (typeof window !== 'undefined') {
      window.history.pushState({ page: 'MEDIAOVERLAY' }, null, '');
    }
  };

  setChildrenElements = (images) => {
    const { product = {}, showFavorites } = this.props;
    const { info = {} } = product;
    const { brandName, productLabel } = info;
    const children = images.map((image, imageIndex) => {
      const {
        collection, collectionId, mediaStill, url, videoStill, type
      } = image;
      const isImage360 = Helper.isImage360({ media: image });
      const isVideo = Helper.isVideo({ media: image });
      const isAR = Helper.isAR({ media: image });
      let thumbnailUrl = image.url;
      if (isVideo) {
        thumbnailUrl = videoStill;
      } else if (isImage360) {
        thumbnailUrl = `${url}?thumb&profile=400`;
      } else if (isAR) {
        thumbnailUrl = mediaStill;
      }
      return (
        <li className="media-gallery-mobile" key={imageIndex}>
          {showFavorites && (
            <Favorite
              collectionId={collectionId}
              className="media-gallery-favorite"
              showCircle
              position="topRight"
              collectionImage={url}
            />
          )}
          <button className="media-gallery-mobile__thumbnails-wrapper" onClick={() => this.onMainImageClick(images, imageIndex, type)} type="button">
            {isImage360
              && (
                <>
                  <span className="background-circle background-circle--main" />
                  <span className="threesixty-icon threesixty-icon--main" />
                </>
              )}
            {isVideo
              && (
                <>
                  <span className="background-circle background-circle--main" />
                  <span className="play-icon play-icon--main" />
                </>
              )}
            {isAR
              && (
                <>
                  <span className="background-circle background-circle--main" />
                  <span className="ar-icon ar-icon--main" />
                </>
              )}
            <img
              className="media-gallery-mobile__thumbnails"
              src={thumbnailUrl}
              alt={`${brandName} ${productLabel}`}
            />
            {collection
            && (
              <div className="shopThisRoomContainer">
                <a className="shopThisRoomLink" href={collection} onClick={(e) => e && e.stopPropagation()}> Shop This Room </a>
              </div>
            )}
          </button>
        </li>
      );
    });
    this.setState({ children });
  };

  handleMediaClick = ({ media }) => {
    const { onMediaClick } = this.props;
    if (onMediaClick) {
      onMediaClick({ media });
    }
  };

  updatePageLayout = () => {
    const { media } = this.props;
    const { main, thumbnails } = media;
    this.setState({
      mainImage: main[0],
      selectedMainImageIndex: 0,
      thumbnails
    });
    this.setChildrenElements(main);
  };

  hideOverlay = () => {
    this.setState({ overlayOpened: false });
  };

  render() {
    const {
      children, overlayOpened, thumbnails, mainImage, selectedMainImageIndex, selectedThumbnailIndex
    } = this.state;
    const { product, media } = this.props;
    const { main = [], zoom = [] } = media;
    const singleImageClass = classNames({ 'single-image': children.length === 1 });
    if (overlayOpened) {
      document.body.style.overflow = 'hidden';
    }

    return (
      <>
        <ul className={`media-gallery-mobile__landscape ${singleImageClass}`}>
          {children}
        </ul>
        <ul className={`media-gallery-mobile__portrait ${singleImageClass}`}>
          {children}
        </ul>
        {overlayOpened
        && (
          <MediaGalleryOverlayMobile
            handleClose={this.hideOverlay}
            overlayOpened={overlayOpened}
            product={product}
            mainImage={mainImage}
            mainImages={main}
            onMediaClick={this.handleMediaClick}
            zoomedImages={zoom}
            thumbnails={thumbnails}
            selectedMainImageIndex={selectedMainImageIndex}
            selectedThumbnailIndex={selectedThumbnailIndex}
          />
        )}
      </>
    );
  }
}

MediaGalleryMobile.propTypes = {
  media: shape({
    main: arrayOf(shape({
      id: string,
      location: string,
      mediaType: string
    })),
    thumbnails: arrayOf(shape({
      id: string,
      location: string,
      mediaType: string
    })),
    zoom: arrayOf(shape({
      id: string,
      location: string,
      mediaType: string
    }))
  }).isRequired,
  onMediaClick: func,
  product: shape({}),
  showFavorites: bool
};

MediaGalleryMobile.defaultProps = {
  onMediaClick: null,
  product: {},
  showFavorites: false
};

export { MediaGalleryMobile };
